export default __webpack_public_path__ + "static/image4-334797329ac177a21b5430acff2f18e9.gif";